import React, { useState } from 'react';
import classNames from 'classnames';
import isEmpty from "lodash/isEmpty";
import AsyncSelect from 'react-select/async';
import { activityInputPropTypes } from '../activity-input-prop-types';
import { customStyles } from '../custom-select/custom-styles';
import { CustomInput } from '../custom-select/CustomInput';
import { CustomMenuList } from '../custom-select/CustomMenuList';
import { formatOptionLabel } from '../custom-select/format-option-label';
import { useActivityInput } from '../use-activity-input';
import {useSearch} from "../../SearchForm/use-search";

export const DesktopActivityInput = (props) => {
  const [showPopularActivitiesModal, setShowPopularActivitiesModal] = useState(false);

  const { intl } = useSearch();
  const placeholder = intl.formatMessage({
    id: 'shared_components.activity-input.activity-input-placeholder',
    defaultMessage: 'Enter your activity'
  });

  const {
    loadOptions,
    isFocused,
    defaultOptions,
    inputDisplay,
    isOptionError,
    formActive,
    value,
    urlPrefix,
    onChange,
    inputChange,
    handleInputFocus,
    handleInputBlur,
    handleContainerFocus,
    activitiesList
  } = useActivityInput(props);

  const getInputColorClass = () => {
    let colorClass = '';
    if (formActive && !isFocused) {
      colorClass += 'text-gray-500';
    } else {
      const hasValue = !(isEmpty(value) || isEmpty(value.value));
      colorClass += hasValue ? 'text-gray-900' : 'text-gray-600';
    }
    return colorClass;
  };

  return (
    <>
      <div
        className="flex column"
        onFocus={handleContainerFocus}
        role='button'
        tabIndex='0'
      >
        <label
          htmlFor='activity-input'
          className={classNames(
            'text-xs no-bottom-margin',
            `${formActive && !isFocused ? 'text-gray-500' : 'text-gray-600'}`
          )}
        >
          {
            intl.formatMessage({
              id: 'shared_components.activity-input.activity-input-label',
              defaultMessage: 'What are you planning?'
            })
          }
        </label>
        {!isFocused ? (
          <button
            className={classNames('readonly_activity_input btn-clear sans-serif',
              getInputColorClass()
            )}
            onClick={(e) => e.preventDefault()}
          >
            {inputDisplay || placeholder}
          </button>
        ) : (
          <AsyncSelect
            id='activity-input'
            instanceId='activity-input'
            controlShouldRenderValue={false}
            placeholder={placeholder}
            isClearable
            autoFocus={true}
            onFocus={handleInputFocus}
            onBlur={handleInputBlur}
            onChange={onChange}
            onInputChange={inputChange}
            inputValue={inputDisplay}
            defaultOptions={defaultOptions}
            loadOptions={loadOptions}
            formatOptionLabel={formatOptionLabel}
            noOptionsMessage={() => null}
            openMenuOnFocus
            getOptionValue={(suggestion) => suggestion.value}
            styles={customStyles(isFocused, formActive, false)}
            components={{
              MenuList: (props) =>
                CustomMenuList(props, isOptionError, urlPrefix, setShowPopularActivitiesModal),
              LoadingIndicator: () => null,
              IndicatorsContainer: () => null,
              Input: CustomInput
            }}
          />
        )}
      </div>
    </>
  );
};

DesktopActivityInput.propTypes = activityInputPropTypes;
